import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSittingMan = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Groupe_2341",
	"data-name": "Groupe 2341",
	xmlns: "http://www.w3.org/2000/svg",
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			id: "Groupe_2216",
			"data-name": "Groupe 2216",
			transform: "translate(0 0)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Groupe_77",
				"data-name": "Groupe 77",
				children: /* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_20",
					"data-name": "Rectangle 20",
					width: 38,
					height: 27.707,
					fill: "none"
				})
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Groupe_2220",
			"data-name": "Groupe 2220",
			transform: "translate(8.74 0.001)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Trac\\xE9_2228",
					"data-name": "Trac\\xE9 2228",
					d: "M446.127,143.736a3.413,3.413,0,0,0-.137-6.071l-4.2-2.036A3.351,3.351,0,0,0,438.522,133h-.135a3.348,3.348,0,0,0-3.344,3.345v9.879a3.7,3.7,0,0,0,3.7,3.7h3.131a.544.544,0,0,1,.543.544v3.285a3.412,3.412,0,1,0,6.824,0v-4.915A5.743,5.743,0,0,0,446.127,143.736Zm.937,10.016a1.237,1.237,0,1,1-2.475,0v-3.285a2.721,2.721,0,0,0-2.718-2.718h-3.131a1.525,1.525,0,0,1-1.523-1.523v-9.879a1.172,1.172,0,0,1,1.17-1.17h.135a1.172,1.172,0,0,1,1.17,1.17v.681l5.349,2.594a1.237,1.237,0,1,1-1.08,2.227l-4.268-2.07v5.495H443.5a3.567,3.567,0,0,1,3.562,3.562Z",
					transform: "translate(-428.719 -124.591)",
					fill: "#68d1df"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trac\\xE9_2229",
					"data-name": "Trac\\xE9 2229",
					d: "M437.169,125.56a4.015,4.015,0,1,0-4.015-4.015A4.02,4.02,0,0,0,437.169,125.56Zm0-5.855a1.84,1.84,0,1,1-1.84,1.841A1.843,1.843,0,0,1,437.169,119.7Z",
					transform: "translate(-427.857 -117.53)",
					fill: "#68d1df"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trac\\xE9_2230",
					"data-name": "Trac\\xE9 2230",
					d: "M433.869,150.106h-4.421v-15a2.1,2.1,0,0,0-2.1-2.1h-1.834a2.105,2.105,0,0,0-2.1,2.1v16.089a4.957,4.957,0,0,0,3.821,4.816V157.1a.36.36,0,0,1-.36.36h-1.182a2.074,2.074,0,0,0-2.072,2.072v.983a2.075,2.075,0,0,0,2.072,2.072H433.9a2.075,2.075,0,0,0,2.072-2.072v-.983a2.074,2.074,0,0,0-2.072-2.072h-1.25a.292.292,0,0,1-.291-.291v-1.027h1.511a2.1,2.1,0,0,0,2.1-2.1v-1.834A2.1,2.1,0,0,0,433.869,150.106Zm-1.22,9.531H433.8v.778h-8.007v-.778h1.08A2.537,2.537,0,0,0,429.4,157.1v-.958h.779v1.027A2.469,2.469,0,0,0,432.649,159.638Zm1.148-5.667h-5.436a2.78,2.78,0,0,1-2.777-2.777V135.176h1.69v15a2.1,2.1,0,0,0,2.1,2.1H433.8Z",
					transform: "translate(-423.41 -124.591)",
					fill: "#68d1df"
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgSittingMan);
export { ForwardRef as ReactComponent };
